import { FEED } from "#/api/associadosFeedBackLogin";
import { Conta } from "#/api/getAgenciaConta";
import { IBensData } from "#/api/getBens";
import { BensGruposReturn } from "#/api/getBens";
import { IProduct } from "#/api/getProducts";
import { IGetVendaResumoData } from "#/api/getVendaResumo";
import { IGetVendasBoletoData } from "#/api/getVendasBoleto";
import { IGetVendasContratoData } from "#/api/getVendasContrato";
import { IGetVendasListaPropostaData } from "#/api/getVendasListaProposta";
import { IGetVendasPlanosCobrancaData } from "#/api/getVendasPlanosCobranca";
import { PAGE } from "#/constants";
import { NavigateFunction } from "react-router-dom";

import { MaintenanceData } from "#/api/getMaintenance";

export type { MaintenanceData };

export interface IPropsContext {
  children: React.ReactElement;
}

export interface IContextProver {
  maintenanceData: MaintenanceData | null;
  homePageInitial: PAGE_INICIAL | FEED | null;
  agencyAccountCommissioned: Conta;
  setAgencyAccountCommissioned: React.Dispatch<React.SetStateAction<Conta>>;
  products: IProduct[];
  setProducts: React.Dispatch<React.SetStateAction<IProduct[]>>;
  userCPF: string;
  documento: string;
  codigoComissionado: string;
  idProduto: number;
  setIdProduto: React.Dispatch<React.SetStateAction<number>>;
  idSubProduto: number | undefined;
  /** identificador único do produto no catálogo (/product), usado para navegação e exibição */
  idComercial: number;
  setIdComercial: React.Dispatch<React.SetStateAction<number>>;
  valorParcela: number;
  setValorParcela: React.Dispatch<React.SetStateAction<number>>;
  isMobile: boolean;
  situacaoGrupo: string;
  idTipoVenda: number;
  idSimulacao: number;
  setIdSimulacao: React.Dispatch<React.SetStateAction<number>>;
  bens: IBensData;
  setBens: React.Dispatch<React.SetStateAction<IBensData>>;

  vendasResumo: IGetVendaResumoData;
  setVendasResumo: React.Dispatch<React.SetStateAction<IGetVendaResumoData>>;
  valorBem: number;
  setValorBem: React.Dispatch<React.SetStateAction<number>>;
  idDocumento: number;
  setIdDocumento: React.Dispatch<React.SetStateAction<number>>;
  seguro: string;
  vendasPlanosCobranca: IGetVendasPlanosCobrancaData;
  setVendasPlanosCobranca: React.Dispatch<
    React.SetStateAction<IGetVendasPlanosCobrancaData>
  >;
  vendasListaProposta: IGetVendasListaPropostaData;
  setVendasListaProposta: React.Dispatch<
    React.SetStateAction<IGetVendasListaPropostaData>
  >;
  vendaBoleto: IGetVendasBoletoData;
  setVendaBoleto: React.Dispatch<React.SetStateAction<IGetVendasBoletoData>>;
  vendasContrato: IGetVendasContratoData;
  setVendasContrato: React.Dispatch<
    React.SetStateAction<IGetVendasContratoData>
  >;
  isCheckAceitoContrato: boolean;
  setIsCheckAceitoContrato: React.Dispatch<React.SetStateAction<boolean>>;
  isOpenNotFoundModal: boolean;
  setIsOpenNotFoundModal: React.Dispatch<React.SetStateAction<boolean>>;
  isOpenCapitalIntegralizadoModal: boolean;
  setIsOpenCapitalIntegralizadoModal: React.Dispatch<
    React.SetStateAction<boolean>
  >;
  isOpenOfertaIndisponivelModal: boolean;
  setIsOpenOfertaIndisponivelModal: React.Dispatch<
    React.SetStateAction<boolean>
  >;
  isOpenCadastroErroModal: boolean;
  setIsOpenCadastroErroModal: React.Dispatch<React.SetStateAction<boolean>>;
  logout: () => Promise<void>;
  isLoading: boolean;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  isHasAuthConta: Conta | null;
  setIsHasAuthConta: React.Dispatch<React.SetStateAction<Conta | null>>;
  isMenuConsorcio: boolean;
  setIsMenuConsorcio: React.Dispatch<React.SetStateAction<boolean>>;
}

export interface INavigateSetIdRoute {
  id: string | null;
  idComercial?: string | number | null;
  setIdProduto: React.Dispatch<React.SetStateAction<number>>;
  navigate: NavigateFunction;
  PAGE: PAGE;
}

export enum PAGE_INICIAL {
  Home = PAGE.ROOT,
}

export interface IGetAgenciaConta {
  contaInput: string;
  agenciaInput: string;
}

export interface IDownloadFilePDF {
  base64DataFile: string;
  nameFile: string;
}
export interface IHandleEmitirRegulamento {
  idProduto: number;
  codigoComissionado: string;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
}
export interface IHandleEmitirBoleto {
  idDocumento: number;
  codigoComissionado: string;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  documento: string;
}
export interface IGetVendasListaPropostaByIdDocumento {
  vendasListaProposta: IGetVendasListaPropostaData;
  idDocumento: number;
}
export interface IVerifyUserHasOnlyOneAccount {
  documento: string;
}
export interface IGetBensGrupoByIdSimulacao {
  bensGrupos: BensGruposReturn[];
  idSimulacao: number;
}
export enum TYPE_OS {
  Windows = "Windows",
  MacOS = "MacOS",
  Linux = "Linux",
  Android = "Android",
  iOS = "iOS",
  Unknown = "Unknown",
}
export interface IGetTotalPaginas {
  quantidadePorPagina: number;
  quantidadeLista: number | undefined;
}
export interface IGetListaPaginacao<T> {
  atualPagina: number;
  quantidadePorPagina: number;
  apiLista: T[] | undefined;
}
export interface IHandleDetalhesContrato {
  conta: string;
  codigoComissionado: string;
  idDocumento: number;
  cooperativa: string;
  documento: string;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  setVendasContrato: React.Dispatch<
    React.SetStateAction<IGetVendasContratoData>
  >;
}
export interface IModalErroApi {
  messageErro: string;
  isOpenModal: boolean;
  setIsOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
}
